import React, { lazy } from 'react';
import { Flame, Target, CheckCircle2, Gift, Zap } from 'lucide-react';
export function ProductSection() {
  return <section className="py-16 md:py-24 bg-warm-50" data-id="element-151">
      <div className="max-w-6xl mx-auto px-4" data-id="element-152">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-charcoal mb-6" data-id="element-154">
            Del Fogón a la Airfryer:{' '}
            <span className="text-primary" data-id="element-155">El Manual de la Comida Típica</span>
          </h2>
          <p className="text-lg md:text-xl text-charcoal-muted" data-id="element-156">
            Un sistema práctico para cocinar típico con Airfryer:{' '}
            <strong className="text-charcoal" data-id="element-157">
              tú pones el antojo, el eBook te da tiempos exactos, y el resultado
              sale crocante
            </strong>{' '}
            sin paila, sin aceite y sin olor.
          </p>
        </div>

        {/* Mechanism Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-158">
          {/* Phase 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-warm-100 relative pt-12" data-id="element-159">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-charcoal text-white w-12 h-12 rounded-full flex items-center justify-center font-heading font-bold text-xl shadow-lg" data-id="element-160">
              1
            </div>
            <div className="flex items-center gap-2 mb-4 justify-center text-primary" data-id="element-161">
              <Target className="w-6 h-6" data-id="element-162" />
              <h3 className="text-xl font-heading font-bold" data-id="element-163">Atención</h3>
            </div>
            <p className="text-sm font-medium text-charcoal-muted text-center mb-6 italic" data-id="element-164">
              Corta el fracaso antes de que nazca.
            </p>
            <ul className="space-y-3" data-id="element-165">
              <li className="flex items-start gap-2" data-id="element-166">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-167" />
                <span className="text-charcoal text-sm" data-id="element-168">
                  Identificas el corte/grosor correcto (sin adivinar)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-169">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-170" />
                <span className="text-charcoal text-sm" data-id="element-171">
                  Preparación mínima para que el aire sí haga su trabajo
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-172">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-173" />
                <span className="text-charcoal text-sm" data-id="element-174">
                  Evitas el "quemado afuera / crudo adentro"
                </span>
              </li>
            </ul>
          </div>

          {/* Phase 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-warm-100 relative pt-12 transform md:-translate-y-4" data-id="element-175">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-primary text-white w-12 h-12 rounded-full flex items-center justify-center font-heading font-bold text-xl shadow-lg" data-id="element-176">
              2
            </div>
            <div className="flex items-center gap-2 mb-4 justify-center text-primary" data-id="element-177">
              <Flame className="w-6 h-6" data-id="element-178" />
              <h3 className="text-xl font-heading font-bold" data-id="element-179">Relevancia</h3>
            </div>
            <p className="text-sm font-medium text-charcoal-muted text-center mb-6 italic" data-id="element-180">
              Dejas de cocinar genérico y empiezas a cocinar "a la colombiana".
            </p>
            <ul className="space-y-3" data-id="element-181">
              <li className="flex items-start gap-2" data-id="element-182">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-183" />
                <span className="text-charcoal text-sm" data-id="element-184">
                  Ajustes por marcas comunes (tabla rápida)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-185">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-186" />
                <span className="text-charcoal text-sm" data-id="element-187">
                  Tiempos pensados para ingredientes de D1, Ara y plaza
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-188">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-189" />
                <span className="text-charcoal text-sm" data-id="element-190">
                  Resultados consistentes sin estar mirando cada minuto
                </span>
              </li>
            </ul>
          </div>

          {/* Phase 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-warm-100 relative pt-12" data-id="element-191">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-accent text-white w-12 h-12 rounded-full flex items-center justify-center font-heading font-bold text-xl shadow-lg" data-id="element-192">
              3
            </div>
            <div className="flex items-center gap-2 mb-4 justify-center text-primary" data-id="element-193">
              <Zap className="w-6 h-6" data-id="element-194" />
              <h3 className="text-xl font-heading font-bold" data-id="element-195">
                Prueba + Acción
              </h3>
            </div>
            <p className="text-sm font-medium text-charcoal-muted text-center mb-6 italic" data-id="element-196">
              El momento del "crunch".
            </p>
            <ul className="space-y-3" data-id="element-197">
              <li className="flex items-start gap-2" data-id="element-198">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-199" />
                <span className="text-charcoal text-sm font-bold" data-id="element-200">
                  Golpe de calor final a 200°C (la diferencia real)
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-201">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-202" />
                <span className="text-charcoal text-sm" data-id="element-203">
                  Textura crocante sin aceite
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-204">
                <CheckCircle2 className="w-5 h-5 text-trust shrink-0 mt-0.5" data-id="element-205" />
                <span className="text-charcoal text-sm" data-id="element-206">
                  Pasos claros para servir y repetir
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bonus Presentation */}
        <div className="bg-gradient-to-br from-warm-100 to-white rounded-3xl p-8 md:p-12 shadow-xl border border-warm-200" data-id="element-207">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-208">
            <div className="flex-1" data-id="element-209">
              <div className="inline-flex items-center gap-2 bg-accent text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider mb-6" data-id="element-210">
                <Gift className="w-4 h-4" data-id="element-211" />
                Bono #1 Incluido
              </div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-charcoal mb-4" data-id="element-212">
                "Proteína & Ligero en Airfryer"
              </h3>
              <p className="text-lg text-charcoal-muted mb-6" data-id="element-213">
                20 recetas en Airfryer para comer más proteína o más liviano,
                con sabor colombiano y ese "crunch" que sí satisface.
              </p>
              <ul className="space-y-3" data-id="element-214">
                <li className="flex items-start gap-3" data-id="element-215">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2.5 shrink-0" data-id="element-216"></div>
                  <span className="text-charcoal" data-id="element-217">
                    Resuelve el "¿y qué más hago en la Airfryer?" con un
                    recetario listo para usar.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-218">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2.5 shrink-0" data-id="element-219"></div>
                  <span className="text-charcoal" data-id="element-220">
                    Disminuye la fricción diaria: cero pensar a la hora de
                    cocinar.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-221">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2.5 shrink-0" data-id="element-222"></div>
                  <span className="text-charcoal" data-id="element-223">
                    Refuerza la promesa: rapidez, cero aceite, cero desorden,
                    sabor real.
                  </span>
                </li>
              </ul>
            </div>
            <div className="w-full md:w-1/3 max-w-sm" data-id="element-224">
              <img src="https://cdn.magicpatterns.com/uploads/jtdYHaHu8MBK9CnHeC8zZ2/IMAGEN_RECETARIO.png" alt="Bono Recetario Proteína y Ligero" className="w-full h-auto drop-shadow-xl rounded-lg transform rotate-2 hover:rotate-0 transition-transform duration-300" loading="lazy" data-id="element-225" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}